import CryptoJS from 'crypto-js'

export const EVENTS = {
  REQUEST_CPS_REVENUE_MODEL: "pushsdk-request-to-use-cps-revenue-model",
};

export async function sendUserData(
  email,
  name,
  department,
  userId,
  partnerAlias
) {
  const preparedUserData = {
    email,
    name,
    pa_department: partnerAlias === "notix" ? partnerAlias : department,
    user_id: userId,
    user_hash: CryptoJS.HmacSHA256(`${userId}`, "6ex74TD_vTMKBW1ZjlFJqQWVd4Y61APmB3sT72ex").toString(CryptoJS.enc.Hex),
    pa_profileLink: `https://intercato.com/pub/publisher/${userId}/view#sites`,
  };

  if (window.Intercom) {
    return window.Intercom("update", preparedUserData);
  }
}

export function trackEvent(event) {
  if (window.Intercom) {
    window.Intercom("trackEvent", event);
  }
}
